import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO/SEO';
import { ServiceSchema, BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicePage from '../components/ServicePage/ServicePage';

// Import IT Security images
import cctv2Image from '../assets/images/services/it/CCTV2.jpg';
import dataCentreImage from '../assets/images/services/it/DATA CENTRE SETUP AND INSTALLATION.jpg';
import emsImage from '../assets/images/services/it/EMS.jpg';
import ems1Image from '../assets/images/services/it/EMS1.jpg';
import entranceManagementImage from '../assets/images/services/it/ENTRANCE MANAGEMENT.jpg';
import intrusionAlarmsImage from '../assets/images/services/it/INTRUSTION ALARMS.jpg';
import structuredCablingImage from '../assets/images/services/it/STRUCTURED CABLING AND NETWORKING.jpg';

// Import IT Security video
import itVideo from '../assets/videos/services/IT_Security.mp4';

// Import IT Security benefits image
import itBenefitsImage from '../assets/images/services/it/CCTV1.jpg';

const ITSecurityPage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <SEO title="IT Security Solutions" description="Comprehensive IT security services in DRC: CCTV surveillance, data centre setup, entrance management, intrusion alarms, and structured cabling by Cool & Care." keywords="IT security DRC, CCTV surveillance, data centre setup, intrusion alarms, structured cabling Kinshasa" />
      <ServiceSchema name="IT Security Solutions" description="Comprehensive IT security including CCTV, data centres, entrance management, and structured cabling." url="/it-security" />
      <BreadcrumbSchema items={[{ name: 'Services', url: '/services' }, { name: 'IT Security', url: '/it-security' }]} />
      <ServicePage
        serviceName={t('servicePage.services.itSecurity.name')}
      serviceDescription={t('servicePage.services.itSecurity.description')}
      videoUrl={itVideo}
      productImages={[
        cctv2Image,
        dataCentreImage,
        emsImage,
        ems1Image,
        entranceManagementImage,
        intrusionAlarmsImage,
        structuredCablingImage
      ]}
      features={t('servicePage.services.itSecurity.features', { returnObjects: true }) as string[]}
      benefits={t('servicePage.services.itSecurity.benefits', { returnObjects: true }) as string[]}
      benefitsImage={itBenefitsImage}
    />
    </>
  );
};

export default ITSecurityPage;
